import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function TermsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">← Back to Godly Match</Link>
        <h1>Terms of Service</h1>
        <p className="legal-effective">Effective date: 7 May 2026</p>

        <h2>1. Acceptance</h2>
        <p>By creating an account on Godly Match, you agree to these Terms of Service. If you do not agree, do not use the app.</p>

        <h2>2. Eligibility</h2>
        <p>You must be at least 18 years old to use Godly Match. By registering, you confirm you are 18 or older. We reserve the right to terminate accounts found to belong to users under 18.</p>

        <h2>3. Your Account</h2>
        <p>You are responsible for keeping your login credentials secure and for all activity that occurs under your account. You must not share your account with anyone else.</p>
        <p>You must provide accurate information when registering and keep your profile honest. Fake profiles, misleading photos, or false information are grounds for immediate account termination.</p>

        <h2>4. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Harass, threaten, or intimidate other users</li>
          <li>Send unsolicited sexual content</li>
          <li>Solicit money or financial information from other users</li>
          <li>Impersonate another person</li>
          <li>Create multiple accounts</li>
          <li>Use automated tools or bots to interact with the platform</li>
          <li>Scrape, copy, or redistribute user data</li>
          <li>Use Godly Match for any commercial purpose without our written permission</li>
          <li>Post content that violates our Community Guidelines</li>
        </ul>

        <h2>5. User Content</h2>
        <p>You own the content you post (photos, bio, messages). By posting content, you grant Godly Match a non-exclusive, royalty-free licence to use, store, display, and distribute that content solely for the purpose of operating the app. You are responsible for ensuring your content does not infringe anyone else's rights.</p>

        <h2>6. Godly+ Subscription</h2>
        <ul>
          <li>Subscriptions are billed monthly or annually as selected at purchase</li>
          <li>Subscriptions auto-renew unless cancelled at least 24 hours before the renewal date</li>
          <li>You can cancel at any time through the Settings page</li>
          <li>Refunds are not provided for partial billing periods except where required by law</li>
          <li>We may change pricing with 30 days' notice to existing subscribers</li>
        </ul>

        <h2>7. Termination</h2>
        <p>We may suspend or terminate your account at any time for violations of these Terms or our Community Guidelines. You may delete your account at any time through Settings.</p>

        <h2>8. Safety Disclaimer</h2>
        <p>Godly Match does not conduct background checks on users and cannot guarantee the accuracy of any profile information. You are responsible for your own safety when interacting with other users, especially when meeting in person. Always meet for the first time in a public place and tell someone you trust where you are going.</p>
        <p>THE APP IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND.</p>

        <h2>9. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, Godly Match is not liable for any indirect, incidental, or consequential damages arising from your use of the app, including damages from interactions with or meetings with other users.</p>

        <h2>10. Governing Law</h2>
        <p>These Terms are governed by the laws of Nigeria. Disputes will be resolved in the courts of Nigeria, unless applicable consumer protection law in your country requires otherwise.</p>

        <h2>11. Changes to These Terms</h2>
        <p>We will notify you of material changes at least 14 days before they take effect by email or in-app notice. Continued use of Godly Match after that date constitutes acceptance of the updated Terms.</p>

        <h2>12. Contact</h2>
        <p>legal@godlymatch.org</p>
      </div>
    </div>
  );
}